import { Component, Input } from '@angular/core';

import { ProductResponseDto, PurchaseDetailResponseDto } from '@api';

import { DefaultModule, PrimeModule } from '@module';
import { ImageFallback } from '@shared/directives/image-fallback.directive';
import { TranslationsPipe } from '@shared/pipe/translations.pipe';

import { Tag } from 'primeng/tag';

interface PurchaseDetailResponseCustomDto extends PurchaseDetailResponseDto {
  'weightCurrent'?: number;
  'sumAmountString'?: string;
}

@Component({
  selector: "shared-products-purchased-detail",
  standalone: true,
  imports: [DefaultModule, PrimeModule, TranslationsPipe, Tag, ImageFallback],
  templateUrl: "./shared-products-purchased-detail.component.html",
  styleUrl: "./shared-products-purchased-detail.component.scss",
})
export class SharedProductsPurchasedDetailComponent {
  @Input() product: ProductResponseDto = {} as ProductResponseDto;
  @Input() purchaseProductData: PurchaseDetailResponseCustomDto = {} as PurchaseDetailResponseCustomDto;
  @Input() isBulkSale: boolean;
}
